module.exports = __webpack_public_path__ + "img/aliado-exotics-logo.7bb24486.png";